
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/latest",
      function () {
        return require("private-next-pages/latest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/latest"])
      });
    }
  